import React from 'react';
import styled from 'styled-components';
import { AbcSection } from '@sections/shared/AbcSection';
import { Box } from '@components/Box';
import { PricingCTA } from '@components/PricingCTA';
import { TextPairing } from '@components/TextPairing';
import { Layout, Seo } from '@layout';
import { useTranslation } from 'react-i18next';

const TextWrapper = styled.div<{ width: string }>`
  max-width: ${(props) => props.width};
  margin: auto;
`;

const Pricing = () => {
  const { t } = useTranslation('pricing');

  return (
    <Layout>
      <Seo title={t('seoText')} canonicalURL={'https://withjoy.com/pricing/'} />
      <Box paddingY={10} paddingX={[7, 7, 11]}>
        <TextWrapper width="445px">
          <TextPairing
            alignment="center"
            title={t('free.title')}
            titleColor="purple6"
            titleVariant="hed72Hero"
            titleTagName="h1"
            body={t('free.content')}
            bodyVariant="dek24"
            bodyColor="purple6"
          />
        </TextWrapper>
        <PricingCTA />
        <TextWrapper width="456px">
          <TextPairing
            alignment="center"
            title={t('revenue.title')}
            titleColor="purple6"
            titleVariant="dek24"
            titleTagName="h3"
            body={t('revenue.content')}
            bodyVariant="featureCopy17"
            bodyColor="purple6"
            bodyWhiteSpace="pre-line"
          />
        </TextWrapper>
      </Box>
      <AbcSection />
    </Layout>
  );
};

export default Pricing;
